import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DataStoreService } from '../../services/data-store';
import { GSCPageRow, GSCDataSet } from '@taptimize/shared';

@Component({
  selector: 'app-content-inventory',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './content-inventory.html',
  styleUrl: './content-inventory.css'
})
export class ContentInventoryComponent implements OnInit {
  urls: GSCPageRow[] = [];
  availableDatasets: string[] = []; // For debugging - show what datasets are available

  constructor(private dataStore: DataStoreService, private router: Router) {}

  ngOnInit() {
    // TODO: Replace CSV data with GSC API integration in the future
    const data = this.dataStore.getData();
    if (data) {
      // Show available datasets for debugging
      this.availableDatasets = data.datasets.map(d => d.type);
      
      // Find the "pages" dataset which contains URL data
      const pagesDataset = data.datasets.find(d => d.type === 'pages');
      if (pagesDataset) {
        // Normalize: ensure every row has a 'page' property
        this.urls = pagesDataset.data.map(row => {
          if (!row.page && row.top_pages) {
            return { ...row, page: row.top_pages };
          }
          return row;
        });
        console.log(`Loaded ${this.urls.length} URLs from pages dataset`);
        // Debug: log the first 5 rows to check their structure
        console.log('First 5 rows:', this.urls.slice(0, 5));
      } else {
        console.log('No "pages" dataset found. Available datasets:', this.availableDatasets);
      }
    } else {
      console.log('No data available in DataStore');
    }
  }

  goToUrlDetail(url: string) {
    // Encode the URL for safe routing
    this.router.navigate(['/inventory', encodeURIComponent(url)]);
  }
} 